




















































import Vue, { PropType } from 'vue'
import XDropdownCaret from './XDropdownCaret.vue'

export type OptionEntry<Key> = { value: Key; label: string }

export default Vue.extend({
  // FIXME data-testidの指定を見直し
  // inheritAttrs: false,
  name: 'XDropDown',
  components: { XDropdownCaret },
  data() {
    return {
      currentValue: this.value,
    }
  },
  props: {
    options: {
      type: Array as PropType<OptionEntry<unknown>[]>,
      required: true,
    },
    value: {
      /**
       * placeholder表示値は`undefined`
       * 未入力の値を統一しそれに合わせる(もしくはコンポーネント内部で変換する)
       * @see https://dev.tavenal.aivick.co.jp/gitbucket/tavenal/ffb/issues/2009
       */
      type: [Number, String],
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    rules: {
      type: [String, Object],
      required: false,
    },
    hideCaret: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value() {
      this.currentValue = this.value
    },
  },
  methods: {
    updateValue() {
      this.$emit('input', this.currentValue)
    },
  },
})
